<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="700px">
      <v-card>
        <!-- Cabeçalho -->
        <v-card-title class="primary white--text">
          <span class="text-h5 font-weight-bold">Duplicar Aula - Polivalência</span>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="$emit('dialogChange', false)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider></v-divider>

        <v-card-text class="pa-6">
          <ValidationObserver v-slot="{ handleSubmit }">
            <form @submit.prevent="handleSubmit(enableSubmit)">
              <!-- Seção: Informações Básicas -->
              <v-card outlined class="mb-6">
                <v-card-title class="subtitle-1 font-weight-bold primary--text">
                  Informações da Aula
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <v-row>
                    <v-col cols="12" sm="6">
                      <div class="info-field">
                        <label class="info-label">Tipo de Aula:</label>
                        <p class="info-value">{{ aulaDuplicada.tipo_de_aula }}</p>
                      </div>
                    </v-col>

                    <v-col cols="12" sm="6">
                      <v-dialog
                        ref="dialog"
                        v-model="modal"
                        :return-value.sync="date"
                        width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <e-label class="info-label">Data da Aula</e-label>
                          <v-text-field
                            dense
                            outlined
                            v-model="data"
                            prepend-inner-icon="mdi-calendar"
                            readonly
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          color="primary"
                          v-model="dataAulaDuplicada"
                          :allowed-dates="allowedDates"
                          scrollable
                          locale="pt-BR"
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="error" @click="modal = false">Cancelar</v-btn>
                          <v-btn text color="primary" @click="$refs.dialog.save(date)"
                            >Confirmar</v-btn
                          >
                        </v-date-picker>
                      </v-dialog>
                    </v-col>
                  </v-row>
                </v-card-text>
              </v-card>

              <!-- Seção: Horários -->
              <v-card outlined class="mb-6">
                <v-card-title class="subtitle-1 font-weight-bold primary--text">
                  Seleção de Horários
                  <e-help-tooltip :text="$constants.tooltips.aulas.duplicarAulaPolivalente" />
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <v-alert v-show="messageAlert" dense outlined type="warning" class="mb-4">
                    {{ messageAlert }}
                  </v-alert>

                  <div
                    v-for="item in JSON.parse(aulaDuplicada.horarios_extras)"
                    :key="item.id"
                    class="mb-4"
                  >
                    <e-label class="font-weight-medium">{{ getNomeDisciplina(item.id) }}</e-label>
                    <e-autocomplete
                      :items="disciplinaHorarios[item.id]"
                      outlined
                      label="Selecione um horário"
                      item-text="descricao"
                      item-value="id"
                      :value="horarios_selecionados_extras[item.id]"
                      return-object
                      dense
                      clearable
                      @change="
                        (val) => {
                          $set(horarios_selecionados_extras, item.id, val);
                          verifyHorariosSelectExtra(val, item.id);
                        }
                      "
                    />
                  </div>
                </v-card-text>
              </v-card>

              <!-- Duplicações adicionais -->
              <div v-for="(dup, dupIndex) in duplicacoesAdicionais" :key="dup._key">
                <v-card outlined class="mb-4">
                  <v-card-title class="subtitle-2 primary--text py-2 px-4">
                    Aula {{ dupIndex + 2 }}
                    <v-spacer />
                    <v-btn icon x-small color="error" @click="removerDuplicacao(dupIndex)">
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-divider />
                  <v-card-text>
                    <v-row>
                      <v-col cols="12" sm="6">
                        <v-dialog v-model="dup.modal" width="290px">
                          <template v-slot:activator="{ on, attrs }">
                            <e-label>Data da Aula</e-label>
                            <v-text-field
                              dense
                              outlined
                              v-model="dup.dataDisplay"
                              prepend-inner-icon="mdi-calendar"
                              readonly
                              v-bind="attrs"
                              v-on="on"
                            />
                          </template>
                          <v-date-picker
                            color="primary"
                            v-model="dup.data"
                            :allowed-dates="allowedDates"
                            scrollable
                            locale="pt-BR"
                          >
                            <v-spacer />
                            <v-btn text color="error" @click="dup.modal = false">Cancelar</v-btn>
                            <v-btn text color="primary" @click="confirmarDataDuplicacao(dupIndex)"
                              >Confirmar</v-btn
                            >
                          </v-date-picker>
                        </v-dialog>
                      </v-col>
                    </v-row>

                    <!-- Seleção de horários por disciplina para esta duplicação -->
                    <div
                      v-for="item in JSON.parse(aulaDuplicada.horarios_extras)"
                      :key="item.id"
                      class="mb-3 mt-2"
                    >
                      <e-label class="font-weight-medium">{{ getNomeDisciplina(item.id) }}</e-label>
                      <e-autocomplete
                        :items="dup.disciplinaHorarios[item.id] || []"
                        outlined
                        label="Selecione um horário"
                        item-text="descricao"
                        item-value="id"
                        :value="dup.horarios_selecionados[item.id]"
                        return-object
                        dense
                        :disabled="!dup.data"
                        @change="
                          (val) => selecionarHorarioDisciplinaDuplicacao(dupIndex, item.id, val)
                        "
                        clearable
                      />
                    </div>

                    <v-alert v-if="dup.temConflito" dense outlined type="warning" class="mt-2 mb-0">
                      Conflito de horário detectado para esta data.
                    </v-alert>
                  </v-card-text>
                </v-card>
              </div>

              <!-- Botão Adicionar Aula -->
              <div class="d-flex align-center mb-6">
                <v-btn
                  color="primary"
                  depressed
                  small
                  :disabled="limiteAtingido"
                  @click="adicionarDuplicacao"
                >
                  <v-icon left small>mdi-plus</v-icon>
                  ADICIONAR AULA
                </v-btn>
                <v-tooltip right>
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon x-small class="ml-1" v-bind="attrs" v-on="on">
                      <v-icon small>mdi-information</v-icon>
                    </v-btn>
                  </template>
                  <span>O LIMITE MÁXIMO PARA DUPLICAÇÃO DE AULA SÃO DE 5 AULAS.</span>
                </v-tooltip>
                <span
                  v-if="limiteAtingido"
                  class="ml-3 error--text text-caption font-weight-medium"
                >
                  VOCÊ ATINGIU O LIMITE DE 5 AULAS
                </span>
              </div>

              <!-- Seção: Planejamento por Disciplina -->
              <v-card outlined class="mb-6">
                <v-card-title class="subtitle-1 font-weight-bold primary--text">
                  Planejamento por Disciplina
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <div
                    v-for="(item, index) in JSON.parse(aulaDuplicada.horarios_extras)"
                    :key="index"
                    class="mb-6"
                  >
                    <v-subheader class="pl-0 font-weight-bold primary--text">
                      {{ getNomeDisciplina(item["id"]) }}
                    </v-subheader>

                    <v-card flat class="pa-4 grey lighten-4 rounded">
                      <div class="mb-3">
                        <label class="info-label">Unidades Temáticas:</label>
                        <p class="text-body-2 mb-0">
                          {{ parseJsonArray(aulaDuplicada.unidades_tematicas)[index] || "-" }}
                        </p>
                      </div>

                      <div class="mb-3">
                        <label class="info-label">Objetos do Conhecimento:</label>
                        <p class="text-body-2 mb-0">
                          {{ parseJsonArray(aulaDuplicada.objeto_conhecimento)[index] || "-" }}
                        </p>
                      </div>

                      <div class="mb-3">
                        <label class="info-label">Habilidades:</label>
                        <p class="text-body-2 mb-0">
                          {{ parseJsonArray(aulaDuplicada.habilidades)[index] || "-" }}
                        </p>
                      </div>

                      <div class="mb-3">
                        <label class="info-label">Objetivo de Aprendizagem:</label>
                        <p class="text-body-2 mb-0">
                          {{ parseJsonArray(aulaDuplicada.objetivo_de_aprendizagem)[index] || "-" }}
                        </p>
                      </div>

                      <div class="mb-3">
                        <label class="info-label">Procedimentos Metodológicos:</label>
                        <p class="text-body-2 mb-0">
                          {{
                            parseJsonArray(aulaDuplicada.procedimentos_metodologicos)[index] || "-"
                          }}
                        </p>
                      </div>

                      <div>
                        <label class="info-label">Material de Apoio:</label>
                        <p class="text-body-2 mb-0">
                          {{ parseJsonArray(aulaDuplicada.material_de_apoio)[index] || "-" }}
                        </p>
                      </div>
                    </v-card>
                    <v-divider
                      v-if="index < JSON.parse(aulaDuplicada.horarios_extras).length - 1"
                      class="mt-4"
                    ></v-divider>
                  </div>
                </v-card-text>
              </v-card>

              <!-- Seção: Avaliação da Aula (Geral) -->
              <v-card outlined class="mb-6">
                <v-card-title class="subtitle-1 font-weight-bold primary--text">
                  Avaliação da Aula
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text>
                  <p class="text-body-1">{{ aulaDuplicada.avaliacao_da_aula || "-" }}</p>
                </v-card-text>
              </v-card>

              <v-divider class="my-6"></v-divider>
              <e-progresso-preenchimento
                :expectedItems="itemsProgresso"
                :filledItems="itemsPreenchidos"
                @total-filled-changed="
                  (value) => $checkTotallyFilled(value, 'totalmentePreenchido')
                "
                :isInfantil="aulaDuplicada.e_aula_infantil === 1"
              />

              <!-- Ações -->
              <v-card-actions class="px-0">
                <v-spacer></v-spacer>
                <v-btn color="error" outlined class="mr-3" @click="$emit('dialogChange', false)">
                  Cancelar
                </v-btn>
                <v-btn
                  color="primary"
                  :disabled="
                    desabilitarSalvamento ||
                    !totalmentePreenchido ||
                    temConflito ||
                    duplicacoesAdicionais.some((d) => d.temConflito)
                  "
                  type="submit"
                  depressed
                >
                  <v-icon left>mdi-content-save</v-icon>
                  Salvar
                </v-btn>
              </v-card-actions>
            </form>
          </ValidationObserver>
        </v-card-text>
      </v-card>
    </v-dialog>

    <e-modal-confirm
      :confirmDialog="confirmDialog"
      :objectModal="objectModal"
      @changeModalConfirm="enableSubmit"
      @changeActionResponse="duplicarAula"
    />
    <aulas-em-conflitos v-model="sheetAulasEmConflito" :aulas="aulasEmConflito" />
  </v-row>
</template>

<script>
import AulasEmConflitos from "@/components/Aulas/AulasEmConflitos.vue";

export default {
  components: {
    AulasEmConflitos,
  },
  props: {
    dialog: {
      type: Boolean,
      default: false,
    },
    submittingForm: {
      type: Boolean,
      default: false,
    },
    form: {
      type: Object,
      require: true,
    },
    gestaoDeAulas: {
      type: Object,
      require: true,
    },
    horarios: {
      type: Array,
      require: true,
    },
    disciplinas: {
      type: Array,
    },
    allowedDates: {
      type: Function,
    },
    tipoAula: {
      type: String,
      require: false,
    },
    gestaoDeAulaCompleta: {
      type: Object,
      require: true,
    },
    todosEventos: {
      type: Array,
      default: () => [],
    },
  },
  mounted() {
    this.array_horarios_extras = JSON.parse(this.aulaDuplicada.horarios_extras).map((item) => ({
      id: item.id,
      array: [],
    }));
    this.buscarTodosHorarios();
    this.carregarTodosHorariosDisciplinas();
  },
  data() {
    return {
      array_horarios_extras: [],
      editarHorario: false,
      horarios_selecionados_extras: [],
      messageAlert: null,
      desabilitarSalvamento: false,
      date: null,
      data: null,
      modal: false,
      menu: false,
      aulaDuplicada: {},
      confirmDialog: false,
      dataAulaDuplicada: null,
      horariosSabado: [],
      horariosFiltrados: [],
      aulasEmConflito: [],
      sheetAulasEmConflito: false,
      temConflito: false,
      objectModal: {
        title: "Duplicar aula - Polivalência",
        message: "Tem certeza que deseja duplicar esta aula?",
      },
      horarioSelecionado: {
        descricao: "Escolha um horario",
      },
      itemsEsperados: [],
      itemsPreenchidos: [],
      totalmentePreenchido: false,
      todosHorariosDisponiveis: [],
      disciplinaHorarios: {},
      duplicacoesAdicionais: [],
    };
  },
  computed: {
    limiteAtingido() {
      return this.duplicacoesAdicionais.length >= 4;
    },
    itemsProgresso() {
      if (this.duplicacoesAdicionais.length === 0) return this.itemsEsperados;
      const horariosExtras = JSON.parse(this.aulaDuplicada?.horarios_extras || "[]");
      const total = 1 + this.duplicacoesAdicionais.length;
      const currentData =
        (this.dataAulaDuplicada ? 1 : 0) +
        this.duplicacoesAdicionais.reduce((sum, d) => sum + (d.data ? 1 : 0), 0);
      const items = [
        { label: "Data", value: "dataAulaDuplicada", count: { current: currentData, total } },
      ];
      horariosExtras.forEach((item) => {
        const nomeDisciplina = this.getNomeDisciplina(item.id);
        const currentHorario =
          (this.horarios_selecionados_extras[item.id] ? 1 : 0) +
          this.duplicacoesAdicionais.reduce(
            (sum, d) => sum + (d.horarios_selecionados[item.id] ? 1 : 0),
            0
          );
        items.push({
          label: `Horário - ${nomeDisciplina}`,
          value: `horarios_selecionados_extras[${item.id}]`,
          count: { current: currentHorario, total },
        });
      });
      return items;
    },
  },
  created() {
    this.itemsEsperados = [{ label: "Data", value: "dataAulaDuplicada" }];

    this.$watch("dataAulaDuplicada", (val) => {
      this.$toggleItemPreenchidoBarraProgresso("dataAulaDuplicada", !!val, this.itemsPreenchidos);
    });

    this.$watch(
      "form",
      (val) => {
        if (val && val.horarios_extras) {
          try {
            const horariosExtras = JSON.parse(val.horarios_extras);

            this.itemsEsperados = this.itemsEsperados.filter(
              (item) => !item.value.startsWith("horarios_selecionados_extras")
            );

            horariosExtras.forEach((item) => {
              const disciplinaNome = this.getNomeDisciplina(item.id);
              const horarioItem = {
                label: `Horário - ${disciplinaNome}`,
                value: `horarios_selecionados_extras[${item.id}]`,
                disciplinaId: item.id,
              };

              this.itemsEsperados.push(horarioItem);

              this.$watch(`horarios_selecionados_extras.${item.id}`, (val) => {
                const shouldAdd = !!val;
                this.$toggleItemPreenchidoBarraProgresso(
                  horarioItem.value,
                  shouldAdd,
                  this.itemsPreenchidos
                );
              });
            });
          } catch (error) {
            this.$handleError(error);
          }
        }
      },
      { immediate: true }
    );
  },
  watch: {
    data(val) {
      JSON.parse(this.aulaDuplicada.horarios_extras || "[]").forEach((element) => {
        if (this.horarios_selecionados_extras[element.id]) {
          this.pesquisaAulas(this.horarios_selecionados_extras[element.id].id, element.id, val);
        }
      });
    },
    dialog: {
      handler(val) {
        if (!val) {
          this.dataAulaDuplicada = null;
          this.data = null;
          this.horarios_selecionados_extras = [];
          this.aulasEmConflito = [];
          this.sheetAulasEmConflito = false;
          this.temConflito = false;
          this.messageAlert = null;
          this.desabilitarSalvamento = false;
          this.duplicacoesAdicionais = [];
        }
      },
    },
    form: {
      immediate: true,
      handler(val) {
        this.aulaDuplicada = val;
      },
    },
    dataAulaDuplicada(value) {
      if (!value) {
        this.data = null;
        this.horariosFiltrados = [];
        return;
      }
      this.horarios_selecionados_extras = [];
      this.array_horarios_extras = [];
      this.messageAlert = null;
      this.temConflito = false;
      this.desabilitarSalvamento = false;
      const date = new Date(value);
      const data_old = new Intl.DateTimeFormat("pt-BR", { timeZone: "UTC" }).format(date);
      this.data = data_old.replaceAll("/", "/");
      const diaDaSemana = date.getDay();
      this.filtrarHorariosPorDiaDaSemana(diaDaSemana);
      this.carregarTodosHorariosDisciplinas();
    },
  },
  methods: {
    adicionarDuplicacao() {
      if (this.limiteAtingido) return;
      const key = Date.now();
      const idx = this.duplicacoesAdicionais.length;
      const horariosExtras = JSON.parse(this.aulaDuplicada.horarios_extras || "[]");
      const arrayHorarios = horariosExtras.map((item) => ({ id: item.id, array: [] }));

      this.duplicacoesAdicionais.push({
        _key: key,
        modal: false,
        data: null,
        dataDisplay: null,
        horarios_selecionados: {},
        array_horarios: arrayHorarios,
        disciplinaHorarios: {},
        temConflito: false,
      });
    },
    removerDuplicacao(idx) {
      this.duplicacoesAdicionais.splice(idx, 1);
    },
    confirmarDataDuplicacao(idx) {
      const dup = this.duplicacoesAdicionais[idx];
      if (!dup.data) return;
      const date = new Date(dup.data);
      dup.dataDisplay = new Intl.DateTimeFormat("pt-BR", { timeZone: "UTC" }).format(date);
      dup.modal = false;
      // Limpa seleções de horário pois a data mudou
      dup.horarios_selecionados = {};
      dup.array_horarios = JSON.parse(this.aulaDuplicada.horarios_extras || "[]").map((item) => ({
        id: item.id,
        array: [],
      }));
      this.carregarHorariosDisciplinasDuplicacao(idx);
    },
    async carregarHorariosDisciplinasDuplicacao(idx) {
      const dup = this.duplicacoesAdicionais[idx];
      if (!dup.data || !this.aulaDuplicada?.horarios_extras) return;
      const horariosExtras = JSON.parse(this.aulaDuplicada.horarios_extras);
      await Promise.all(
        horariosExtras.map((item) => this.carregarHorariosDisciplinaDuplicacao(idx, item.id))
      );
    },
    async carregarHorariosDisciplinaDuplicacao(idx, disciplineId) {
      const dup = this.duplicacoesAdicionais[idx];
      const horarios = await this.getFilteredHorariosByDisciplineForDup(idx, disciplineId);
      this.$set(dup.disciplinaHorarios, disciplineId, horarios);
    },
    async getFilteredHorariosByDisciplineForDup(idx, disciplineId) {
      const dup = this.duplicacoesAdicionais[idx];
      if (!dup.data || !this.gestaoDeAulaCompleta?.relacoesDiasHorarios) return [];

      const dataYMD = this.toYMD(dup.data);
      const diaDaSemana = new Date(dataYMD).getDay();
      const evento = (this.todosEventos || []).find((ev) => this.toYMD(ev.data) === dataYMD);

      if (evento && (evento.is_sabado_letivo === true || evento.is_sabado_letivo === 1)) {
        if (!this.todosHorariosDisponiveis?.length) await this.buscarTodosHorarios();
        return this.todosHorariosDisponiveis || [];
      }

      return this.gestaoDeAulaCompleta.relacoesDiasHorarios
        .filter((r) => r.dia.id === diaDaSemana && r.disciplina.id === disciplineId)
        .map((r) => r.horario);
    },
    selecionarHorarioDisciplinaDuplicacao(idx, disciplinaId, val) {
      const dup = this.duplicacoesAdicionais[idx];

      if (val?.id && dup.data) {
        const emUsoEmOutraLinha = this.duplicacoesAdicionais.some(
          (d, i) =>
            i !== idx && d.data === dup.data && d.horarios_selecionados[disciplinaId]?.id === val.id
        );
        const emUsoNaLinhaPrimaria =
          this.dataAulaDuplicada === dup.data &&
          this.horarios_selecionados_extras[disciplinaId]?.id === val.id;
        if (emUsoEmOutraLinha || emUsoNaLinhaPrimaria) {
          this.$toast.danger(
            "Esta data e horário já estão sendo usados em outra aula desta duplicação."
          );
          this.$set(dup.horarios_selecionados, disciplinaId, null);
          return;
        }
      }

      this.$set(dup.horarios_selecionados, disciplinaId, val);

      const existing = dup.array_horarios.find((i) => i.id === disciplinaId);
      if (existing) {
        existing.array = val ? [val.id] : [];
      }

      this.verificarConflitosHorariosDuplicacao(idx, disciplinaId);

      if (dup.data && val) {
        this.verificarConflitoDuplicacao(idx, val.id);
      }
    },
    verificarConflitosHorariosDuplicacao(idx, disciplinaId) {
      const dup = this.duplicacoesAdicionais[idx];
      const currentDisciplina = dup.array_horarios.find((i) => i.id === disciplinaId);
      if (!currentDisciplina || !currentDisciplina.array.length) return;

      const horarioId = currentDisciplina.array[0];
      const conflito = dup.array_horarios.some(
        (item) => item.id !== disciplinaId && item.array.includes(horarioId)
      );

      if (conflito) {
        const horarioObj = (dup.disciplinaHorarios[disciplinaId] || []).find(
          (h) => h.id === horarioId
        );
        this.$toast.danger(
          `Outro componente curricular já está usando o horário ${horarioObj?.descricao || ""}!`
        );
        this.$set(dup.horarios_selecionados, disciplinaId, null);
        currentDisciplina.array = [];
      }
    },
    async verificarConflitoDuplicacao(idx, horarioId) {
      const dup = this.duplicacoesAdicionais[idx];
      if (!dup.data || !horarioId) return;

      try {
        const response = await this.$services.aulasService.pesquisarAulasEmConflitosPoli(
          dup.data,
          horarioId,
          this.aulaDuplicada.turma_id,
          0
        );
        if (response.data.conflito) {
          dup.temConflito = true;
          const aulasConflito = response.data.aulas || [];
          if (aulasConflito.length > 0) {
            this.aulasEmConflito = aulasConflito.map((conflito) => ({
              id: conflito.id,
              professor: { nome: conflito.instrutor },
              situacao: conflito.situacao || "Aguardando",
              data: dup.data,
              turma: {
                descricao: conflito.turma,
                franquia: { descricao: conflito.franquia },
              },
              disciplina: { descricao: conflito.disciplina_descricao },
              horario: conflito.horario,
            }));
            this.sheetAulasEmConflito = true;
          }
        } else {
          dup.temConflito = false;
        }
      } catch (error) {
        this.$handleError(error);
      }
    },
    parseJsonArray(value) {
      if (!value) return [];
      try {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed : [parsed];
      } catch {
        return [value];
      }
    },
    toYMD(v) {
      if (!v) return "";

      if (typeof v === "string") {
        if (/^\d{4}-\d{2}-\d{2}/.test(v)) {
          return v.slice(0, 10);
        }

        const parts = v.split("/");
        if (parts.length === 3) {
          const [dia, mes, ano] = parts;
          return `${ano}-${mes.padStart(2, "0")}-${dia.padStart(2, "0")}`;
        }

        if (v.length > 10) return v.slice(0, 10);
      }

      const d = v instanceof Date ? v : new Date(v);
      return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(
        d.getDate()
      ).padStart(2, "0")}`;
    },

    async filtrarHorariosPorDiaDaSemana(diaDaSemana) {
      try {
        if (!this.gestaoDeAulas?.gestao?.relacoesDiasHorarios) {
          this.horariosFiltrados = [];
          return;
        }

        let horariosDoDia = [];

        if (diaDaSemana === 5) {
          horariosDoDia = this.gestaoDeAulas.gestao.relacoesDiasHorarios.map(
            (relacao) => relacao.horario
          );
        } else {
          horariosDoDia = this.gestaoDeAulas.gestao.relacoesDiasHorarios
            .filter((relacao) => relacao.dia.id === diaDaSemana)
            .map((relacao) => relacao.horario);
        }

        this.horariosFiltrados = horariosDoDia;
      } catch (error) {
        this.horariosFiltrados = [];
      }
    },

    async buscarTodosHorarios() {
      try {
        const response = await this.$services.gestoesDeAulasService.getAllHorarios();
        const horariosData = response.data || response;
        this.todosHorariosDisponiveis = horariosData.map((h) => ({
          id: h.id,
          turno_id: h.turno_id,
          descricao: h.descricao || "Horário",
          final: h.final,
          inicio: h.inicio,
        }));

        return this.todosHorariosDisponiveis;
      } catch (error) {
        this.$handleError(error);
        return [];
      }
    },

    async getFilteredHorariosByDisciplineModal(disciplineId) {
      if (!this.data || !this.gestaoDeAulaCompleta?.relacoesDiasHorarios) {
        return [];
      }

      const diaDaSemana = new Date(this.toYMD(this.data)).getDay();
      const dataFormatada = this.toYMD(this.data);
      const evento = (this.todosEventos || []).find((ev) => this.toYMD(ev.data) === dataFormatada);

      if (evento && (evento.is_sabado_letivo === true || evento.is_sabado_letivo === 1)) {
        if (!this.todosHorariosDisponiveis || this.todosHorariosDisponiveis.length === 0) {
          await this.buscarTodosHorarios();
        }
        return this.todosHorariosDisponiveis || [];
      }

      const filteredRelations = this.gestaoDeAulaCompleta.relacoesDiasHorarios.filter(
        (r) => r.dia.id === diaDaSemana && r.disciplina.id === disciplineId
      );

      return filteredRelations.map((r) => r.horario);
    },

    async carregarTodosHorariosDisciplinas() {
      if (this.aulaDuplicada && this.aulaDuplicada.horarios_extras) {
        const horariosExtrasParsed = JSON.parse(this.aulaDuplicada.horarios_extras);

        await Promise.all(
          horariosExtrasParsed.map((item) => this.carregarHorariosDisciplina(item.id))
        );
      }
    },

    async carregarHorariosDisciplina(disciplineId) {
      this.$set(
        this.disciplinaHorarios,
        disciplineId,
        await this.getFilteredHorariosByDisciplineModal(disciplineId)
      );
    },

    getHorariosDaAula(aula) {
      try {
        if (!aula?.horarios_extras) return [];
        return JSON.parse(aula.horarios_extras);
      } catch (error) {
        return [];
      }
    },

    getArrayHorarios(idsHorarios) {
      if (!idsHorarios || !this.horariosFiltrados) return [];
      return idsHorarios
        .map((id) => this.horariosFiltrados.find((horario) => horario.id === id))
        .filter(Boolean);
    },

    valoresComuns(array1, array2) {
      return array1.filter((valor) => array2.includes(valor));
    },
    verifyHorariosSelectExtra(item, disciplinaId) {
      try {
        if (!item) {
          const disciplina = this.array_horarios_extras.find((i) => i.id === disciplinaId);
          if (disciplina) disciplina.array = [];
          return;
        }

        if (!this.array_horarios_extras.some((i) => i.id === disciplinaId)) {
          this.array_horarios_extras.push({
            id: disciplinaId,
            array: [],
          });
        }

        const disciplina = this.array_horarios_extras.find((i) => i.id === disciplinaId);
        disciplina.array = [item.id];

        this.verificarConflitosHorarios(disciplinaId);

        if (this.data) {
          this.pesquisaAulas(item.id, disciplinaId);
        }
      } catch (error) {
        this.$handleError(error);
      }
    },

    verificarConflitosHorarios(disciplinaId) {
      const currentDisciplina = this.array_horarios_extras.find((item) => item.id === disciplinaId);
      if (!currentDisciplina || currentDisciplina.array.length === 0) return;

      const horarioId = currentDisciplina.array[0];

      const conflito = this.array_horarios_extras.some(
        (item) => item.id !== disciplinaId && item.array.includes(horarioId)
      );

      if (conflito) {
        const horarioObj = this.horariosFiltrados.find((h) => h.id === horarioId);
        this.$toast.danger(
          `Outro componente curricular já está usando o horário ${horarioObj?.descricao || ""}!`
        );

        this.$set(this.horarios_selecionados_extras, disciplinaId, null);
        currentDisciplina.array = [];
      }
    },
    getObjHorario(id) {
      if (id) {
        const dis = this.horarios.filter((obj) => obj.id === id);
        return dis[0].descricao;
      }
    },
    getNomeDisciplina(id) {
      if (!this.gestaoDeAulas || !Array.isArray(this.gestaoDeAulas.disciplinas_com_descricao)) {
        return "Componente Curricular não encontrado (dados incompletos)";
      }
      const dis = this.gestaoDeAulas.disciplinas_com_descricao.filter((obj) => obj.id === id);
      return dis.length > 0 ? dis[0].descricao : "Componente Curricular não encontrado";
    },
    async pesquisaAulas(horarioId, disciplinaId) {
      const data_aula = this.data.split("/").reverse().join("-");
      const turma_id = this.aulaDuplicada.turma_id;

      if (!data_aula || !horarioId || !this.aulaDuplicada) return;

      try {
        const response = await this.$services.aulasService.pesquisarAulasEmConflitosPoli(
          data_aula,
          horarioId,
          turma_id,
          0
        );

        this.messageAlert = null;
        this.desabilitarSalvamento = false;
        this.temConflito = false;

        if (response.data.conflito) {
          this.$set(this.horarios_selecionados_extras, disciplinaId, null);
          const disciplinaConflito = this.array_horarios_extras.find((i) => i.id === disciplinaId);
          if (disciplinaConflito) disciplinaConflito.array = [];

          const aulasConflito = response.data.aulas || [];

          const conflitosFormatados = aulasConflito.map((conflito) => ({
            id: conflito.id,
            professor: {
              nome: conflito.instrutor,
            },
            situacao: conflito.situacao || "Aguardando",
            data: data_aula,
            turma: {
              descricao: conflito.turma,
              franquia: {
                descricao: conflito.franquia,
              },
            },
            disciplina: {
              descricao: conflito.disciplina_descricao,
            },
            horario: conflito.horario,
          }));

          this.aulasEmConflito = conflitosFormatados;
          this.sheetAulasEmConflito = true;
          this.temConflito = true;
          this.messageAlert =
            "Já existe aula registrada nessa data com esses mesmos horários, selecione uma outra data!";
          this.desabilitarSalvamento = true;
        } else {
          this.aulasEmConflito = [];
          this.sheetAulasEmConflito = false;
          this.temConflito = false;
        }
      } catch (error) {
        this.$handleError(error);
      }
    },
    enableSubmit() {
      const horariosExtras = JSON.parse(this.aulaDuplicada.horarios_extras || "[]");

      const todosPreenchidos = horariosExtras.every(
        (item) => !!this.horarios_selecionados_extras[item.id]
      );
      if (!this.data || !todosPreenchidos) {
        this.$toast.danger("Preencha todos os horários de todas as disciplinas.");
        return;
      }

      const dupInvalida = this.duplicacoesAdicionais.some((dup) => {
        if (!dup.data) return true;
        return horariosExtras.some((item) => !dup.horarios_selecionados[item.id]);
      });
      if (dupInvalida) {
        this.$toast.danger(
          "Por favor, preencha a data e os horários de todas as aulas adicionadas."
        );
        return;
      }

      this.confirmDialog = !this.confirmDialog;
      this.aulaDuplicada.data = this.dataAulaDuplicada;
    },
    async duplicarAula() {
      this.$loaderService.open("Duplicando as Aulas");
      try {
        const service =
          this.tipoAula === "complementar"
            ? this.$services.aulasComplementaresService
            : this.$services.aulasService;

        const basePayload = {
          ...this.aulaDuplicada,
          horario_inicial: this.horarioSelecionado?.inicio ?? null,
          horario_final: this.horarioSelecionado?.final ?? null,
          horario_id: this.horarioSelecionado?.id ?? null,
          gestao_de_aula: parseInt(this.$route.params.gestaoDeAulaId, 10),
          disciplina_id: this.gestaoDeAulas.disciplina_id,
          turma_id: this.gestaoDeAulas.turma_id,
          instrutor_id: this.gestaoDeAulas.instrutor_id,
        };

        // Cria aula principal
        await service.criar({
          ...basePayload,
          horarios_extras: JSON.stringify(
            this.array_horarios_extras.map((item) => ({ id: item.id, array: item.array }))
          ),
        });

        await this.duplicacoesAdicionais.reduce(
          (chain, dup) =>
            chain.then(() =>
              service.criar({
                ...basePayload,
                data: dup.data,
                horario_inicial: null,
                horario_final: null,
                horario_id: null,
                horarios_extras: JSON.stringify(
                  dup.array_horarios.map((item) => ({ id: item.id, array: item.array }))
                ),
              })
            ),
          Promise.resolve()
        );

        this.confirmDialog = !this.confirmDialog;
        this.$emit("dialogChange", false);
        const total = 1 + this.duplicacoesAdicionais.length;
        this.$toast.success(
          total === 1 ? "Aula duplicada com sucesso!" : `${total} aulas duplicadas com sucesso!`
        );
        this.$router.push({ name: "aulas" });
      } catch (error) {
        this.$handleError(error);
      }
      this.$loaderService.close();
    },
  },
};
</script>

<style scoped>
.info-field {
  margin-bottom: 12px;
}
.info-label {
  font-size: 0.875rem;
  color: rgba(0, 0, 0, 0.6);
  font-weight: 500;
  display: block;
  margin-bottom: 4px;
}
.info-value {
  font-size: 1rem;
  color: rgba(0, 0, 0, 0.87);
  margin: 0;
}
</style>
